import React, { useState, useEffect } from 'react';
import { ArrowUp } from '../../icons/arrow/arrow';
import StyledBackToTop from './backToTop.style';
import Headline from '../../atoms/headline/headline';

const BackToTop = () => {
  const [isBackToTop, setIsBackToTop] = useState(false);

  const handleBackToTopScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const { scrollHeight } = document.documentElement;
    const { clientHeight } = document.documentElement;

    if (scrollHeight - scrollTop - clientHeight < 1600) {
      setIsBackToTop(true);
    } else {
      setIsBackToTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleBackToTopScroll);

    return () => {
      window.removeEventListener('scroll', handleBackToTopScroll);
    };
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <StyledBackToTop>
      {isBackToTop && (
        <button type="button" onClick={handleBackToTop} className="back-to-top" aria-label="To top">
          <ArrowUp aria-hidden="true" />
          <Headline subline tag="span" className="back-to-top__title">
            To Top
          </Headline>
        </button>
      )}
    </StyledBackToTop>
  );
};

export default BackToTop;
